import { useNavigate } from 'react-router-dom';
import { useForcedPasswordChange } from '@react-apps/auth';
import { authContainer } from '../../di/container';
import { useAuthStore } from '../store/auth.store';
import type { SignInResponse } from '../../domain/entities/auth.entity';
import { extractRoles } from '../../domain/entities/auth.entity';

/**
 * Adaptador deste app sobre a troca obrigatória compartilhada
 * (`@react-apps/auth`). O que fica aqui é só o que é daqui: como a resposta de
 * sign-in vira snapshot (com as `roles`, que o user-dashboard não tem) e para
 * onde ir quando a sessão se perde.
 */
export function useChangePassword() {
  const { setAuth } = useAuthStore();
  const navigate = useNavigate();

  return useForcedPasswordChange<SignInResponse>({
    port: authContainer.repository,
    onAuthenticated: (data, email) => {
      setAuth({
        accessToken: data.accessToken ?? data.tokens?.accessToken ?? '',
        accountId: data.account?.id ?? data.user?.id ?? '',
        email: data.account?.email ?? data.user?.email ?? email,
        roles: extractRoles(data),
      });
    },
    // A senha já mudou e o re-login falhou: a sessão já caiu (esperada) quando
    // isto roda. A `SignInPage` mostra o `state.message`.
    onSessionLost: (message, cause) => {
      // Este é o único caminho do fluxo que redireciona, então a causa não pode
      // sumir — sem ela, "voltei pro login" é indepurável (visto em teste
      // manual, 2026-09-04).
      console.error('[auth] re-login após troca de senha falhou', cause);
      void navigate('/sign-in', { state: { message } });
    },
  });
}
